import { h } from './chunk-DCAKKOYV.js';

async function r(t,o){let[{DotLottieStateMachineManager:a}]=await Promise.all([import('./dotlottie-state-machine-manager-Q62SRANX.js')]);if(!t.length)throw h("No state machines available inside this .lottie!");return new a(t,o)}

export { r as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-775FELTH.js.map